import CONFIG from "@bd-core/config";
import $ from "jquery";

export const Navigation = () => {
    const $navigation = $("#navigation");

    if (!$navigation.length) {
        return;
    }

    // Popup elements
    const popups = {
        profile: $("#card-profile-popup"),
        qrCode: $("#qr-code-page"),
        collections: $("#card-collection-page"),
        missions: $("#mission-detail-popup"),
        leaderboard: $("#leaderboard-page"),
    };

    // Close buttons
    const closeButtons = {
        profile: $("#card-profile-close"),
        qrCode: $("#qr-code-close"),
        collections: $("#card-collection-close"),
        missions: $("#mission-detail-close"),
    };

    // Action to popup key mapping
    const actionMap = {
        "open-profile": "profile",
        "open-qr-code": "qrCode",
        "open-collections": "collections",
        "open-missions": "missions",
        "open-leaderboard": "leaderboard",
    };

    // Popup key to active class mapping
    const activeClassMap = {
        profile: "navigation__item--active-orange",
        qrCode: "navigation__item--active-orange",
        collections: "navigation__item--active-orange",
        missions: "navigation__item--active-orange",
        leaderboard: "navigation__item--active-orange",
    };

    const openPopup = (popupKey) => {
        const $popup = popups[popupKey];

        closeAllPopups();

        const activeClass =
            $popup.attr("id") === "card-added-popup" ? "is-active" : "active";
        $popup.addClass(activeClass);

        $("body").css("overflow", "hidden");
        setActiveNavItem(popupKey);

        $(document).trigger("navigation:popup-opened", { popup: popupKey });
    };

    const closePopup = (popupKey) => {
        const $popup = popups[popupKey];

        if (!$popup || !$popup.length) {
            return;
        }

        $popup.removeClass("active is-active");
        $("body").css("overflow", "");
        clearActiveNavItem();

        $(document).trigger("navigation:popup-closed", { popup: popupKey });
    };

    const closeAllPopups = () => {
        $.each(popups, (key, $popup) => {
            if ($popup && $popup.length) {
                $popup.removeClass("active is-active");
            }
        });

        $("body").css("overflow", "");
        clearActiveNavItem();
    };

    const setActiveNavItem = (popupKey) => {
        const action = Object.keys(actionMap).find(
            (key) => actionMap[key] === popupKey,
        );
        const activeClass = activeClassMap[popupKey];
        if (!action) return;

        clearActiveNavItem();

        const $button = $navigation.find(`[data-action="${action}"]`);
        if ($button.length && activeClass) {
            $button.addClass(`navigation__item--active ${activeClass}`);
        }
    };

    const clearActiveNavItem = () => {
        $navigation
            .find(".navigation__item")
            .removeClass(
                "navigation__item--active navigation__item--active-blue navigation__item--active-orange navigation__item--active-green",
            );
    };

    const updateAvatar = (avatarUrl) => {
        const $profileBtn = $navigation.find(".navigation__profile");
        const $avatar = $profileBtn.find(".navigation__avatar");
        const $avatarImg = $avatar.find(".navigation__avatar-img");
        const $avatarIcon = $avatar.find(".navigation__avatar-icon");

        if (!$avatar.length) return;

        if (avatarUrl) {
            $profileBtn
                .removeClass("navigation__profile--no-avatar")
                .addClass("navigation__profile--has-avatar");
            $avatarImg.attr("src", avatarUrl).show();
            $avatarIcon.hide();
        } else {
            $profileBtn
                .removeClass("navigation__profile--has-avatar")
                .addClass("navigation__profile--no-avatar");
            $avatarImg.hide();
            $avatarIcon.show();
        }
    };

    // Bind navigation button clicks
    $navigation.on("click", "[data-action]", function (e) {
        e.preventDefault();
        const action = $(this).data("action");
        const popupKey = actionMap[action];

        if (popupKey) {
            openPopup(popupKey);
        } else {
            console.warn(`Unknown navigation action: ${action}`);
        }
    });

    // Bind close button clicks
    $.each(closeButtons, (key, $btn) => {
        if ($btn && $btn.length) {
            $btn.on("click", (e) => {
                e.preventDefault();
                closePopup(key);
            });
        }
    });

    // Bind ESC key to close popups
    $(document).on("keydown", (e) => {
        if (e.key === "Escape") {
            closeAllPopups();
        }
    });

    $(document).ready(() => {
        const currentPage = CONFIG.game.current_page;
        switch (currentPage) {
            case "mission":
                setActiveNavItem("missions");
                break;
            case "collection":
                setActiveNavItem("collections");
                break;
            default:
                setActiveNavItem(currentPage);
                break;
        }
    });

    // Expose methods globally
    /**
     * @typedef {Object} NavigationAPI
     * @property {function(string): void} openPopup - Opens a popup by key
     * @property {function(string): void} closePopup - Closes a popup by key
     * @property {function(): void} closeAllPopups - Closes all open popups
     * @property {function(string|null|undefined): void} updateAvatar - Updates the navigation avatar image
     * @property {function(string|null|undefined): void} setActiveNavItem - Sets the active navigation item
     */
    /**
     * @typedef {Window & { navigation?: NavigationAPI }} WindowWithNavigation
     * @type {NavigationAPI}
     */
    // @ts-ignore - navigation property is added dynamically
    window.navigation = {
        openPopup,
        closePopup,
        closeAllPopups,
        updateAvatar,
        setActiveNavItem,
    };
};

export default Navigation;
